import { GenericField } from "@SeemplicityDev/ticket-master";
export default GenericField;

export { fieldTypeOptions } from "@SeemplicityDev/ticket-master";
